export enum GalleryPackType {
  Regular = 'gallery_pack_regular',
  Premium = 'gallery_pack_premium',
  Jumbo = 'gallery_pack_jumbo',
}

export enum GalleryPieceRarity {
  Common = 'gallery_pieces_common',
  Rare = 'gallery_pieces_rare',
  Epic = 'gallery_pieces_epic',
}

export enum GalleryPieceRarityShorthand {
  Common = 'common',
  Rare = 'rare',
  Epic = 'epic',
}

export enum ConversionType {
  Common = 'conversion_common_to_rare',
  Rare = 'conversion_rare_to_epic',
}

export enum GalleryCollectionState {
  Locked = 'locked',
  Opened = 'opened',
  InProgress = 'in_progress',
  CompletedUnclaimed = 'completed_unclaimed',
  CompletedClaimed = 'completed_claimed',
}

export enum GalleryCollectionType {
  Discipline = 'discipline',
  Event = 'event',
}

export enum GalleryPictureState {
  Locked = 'locked',
  Opened = 'opened',
  InProgress = 'in_progress',
  CompletedUnclaimed = 'completed_unclaimed',
  CompletedClaimed = 'completed_claimed',
  Redeemable = 'redeemable',
}

export enum GalleryPictureCategory {
  Collection = 'collection',
  Repeatable = 'repeatable',
  Special = 'special',
}

export enum GalleryPictureUnlockCondition {
  PersonalBest = 'personal_best',
  Offer = 'offer_bought',
  Club = 'club_joined',
  Level = 'level_reached',
  Milestone = 'reach_individual_milestone',
  MilestonePremium = 'reach_individual_premium_milestone',
  ClaimChest = 'claim_chest_at_shooting_range',
  PlayoffAdvance = 'advance_to_playoff_draw',
  FinishTasks = 'finish_tasks_in_chain_at_level',
}
